import React, { useEffect, useState } from "react";
import axios from "axios";
import Cokkie from "../../Components/Cookie";
import WhyIpurvey from "../../Components/HomeComp/WhyIpurvey";
import "./Home.css";
import GetApp from "../../Components/GetApp";
import IpurveySpecial from "../../Components/HomeComp/IpurveySpecial";
import Flights from "../../Components/HomeComp/Flights";
import PaymentMethod from "../../Components/HomeComp/PaymentMethod";
import Trusted from "../../Components/HomeComp/Trusted";
import ChatBox from "../../Components/ChatBox";
import VideoSection from "../../Components/HomeComp/VideoSection";
import AnimationSection from "../../Components/AnimationSection";
import StartedForm from "../../Components/HomeComp/StartedForm";
import Footer from "../../Layout/Footer";
import Loader from "../../Components/Loader";

const Home = () => {
  const [data, setData] = useState();
  useEffect(async () => {
    const home = await axios.get(
      "https://staging-cms-main.ipurvey.com/homepage"
    );
    const layout = await axios.get(
      "https://staging-cms-main.ipurvey.com/layout"
    );
    setData([home.data, layout.data]);
  }, []);
  if (data) {
    return (
      <>
        <div className="home_container">
          <Cokkie data={data[1]} />
          <ChatBox />
          <AnimationSection
            data={data[0]}
            forms={<StartedForm data={data[0]} />}
          />
          <WhyIpurvey />
          <VideoSection />
          <IpurveySpecial />
          <Flights />
          <PaymentMethod />
          <Trusted />
          <GetApp data={data[1]} />
        </div>
        <Footer data={data[1]} />
      </>
    );
  } else {
    return <Loader />;
  }
};

export default Home;
